import { RenderedBaseHubBlockNodeView } from './node-view'
import {
  BaseHubInlineBlock,
  BaseHubBlock as PrimitiveBaseHubBlock,
} from '@basehub/tiptap-api-utils'
import { Editor } from '@tiptap/core'
import { Plugin, PluginKey, TextSelection } from '@tiptap/pm/state'
import { mapSlice } from '../_helpers'
import { Slice } from '@tiptap/pm/model'
import { EditorView } from '@tiptap/pm/view'

export const BaseHubBlock = PrimitiveBaseHubBlock.extend({
  addNodeView() {
    return RenderedBaseHubBlockNodeView
  },
  // addProseMirrorPlugins() {
  //   return [
  //     pasteHandler({
  //       editor: this.editor,
  //       cb: this.options.callbackOnPaste,
  //     }),
  //   ]
  // },
})

interface PasteHandlerOptions {
  editor: Editor
  cb: (
    editor: Editor,
    id: string,
    q?: number
  ) => string | undefined | void | false | null
}

export function pasteHandler(_options: PasteHandlerOptions): Plugin {
  return new Plugin({
    key: new PluginKey('handlePasteBaseHubBlock'),
    props: {
      // Event handler for paste
      handlePaste(view, event, slice): boolean {
        // Check if it's a paste event
        if (event.type === 'paste') {
          // Perform transformation on paste
          transformBasehubBlockPasted(_options.editor, slice, (id: string) =>
            _options.cb(_options.editor, id, 0)
          )
          return true // Prevent the default paste behavior
        }
        return false // Allow the default drop behavior
      },
      handleDrop(view, event, slice, moved): boolean {
        return handleDrop(view, event, slice, moved, _options)
      },
    },
  })
}

// Event handler for paste

// Function to transform content on paste
export function transformBasehubBlockPasted(
  editor: Editor,
  slice: Slice,
  cb: (id: string) => string | undefined | void | false | null
): void {
  // Transform the slice
  let changed = false
  const transformedSlice = mapSlice(slice, (node) => {
    if (node.type.name === BaseHubBlock.name) {
      const id = cb(node.attrs.id)
      if (id === false) return null

      const bashubBlockNode = editor.state.schema.nodes[BaseHubBlock.name]
      if (id && bashubBlockNode) {
        changed = true
        return bashubBlockNode.create({ id })
      }
    } else if (node.marks) {
      const mark = node.marks.find(
        (mark) => mark.type.name === BaseHubInlineBlock.name
      )
      if (!mark) return node
      const id = cb(mark.attrs.id)
      if (id === false) {
        changed = true
        return node.mark(
          node.marks.filter(
            (mark) => mark.type.name !== BaseHubInlineBlock.name
          )
        )
      }

      if (id) {
        changed = true
        return node.mark([
          ...node.marks.filter(
            (mark) => mark.type.name !== BaseHubInlineBlock.name
          ),
          editor.state.schema.marks[BaseHubInlineBlock.name]!.create({
            id,
          }),
        ])
      }
    }
    return node
  })
  // Apply the transformed slice
  const result = editor.view.state.tr.replaceSelection(transformedSlice)
  if (changed) {
    editor.view.dispatch(result)
  }
}

function handleDrop(
  view: EditorView,
  event: DragEvent,
  slice: Slice,
  moved: boolean,
  _options: PasteHandlerOptions
): boolean {
  if (moved) return false
  const { state, dispatch } = view
  const tr = state.tr

  // Get the drop position
  const dropPosition = view.posAtCoords({
    left: event.clientX,
    top: event.clientY,
  })

  // If dropPosition is null, return false to allow default behavior
  if (!dropPosition) return false

  // Transform the slice if needed (you can add your transformation logic here)
  const transformedSlice = transformSlice(
    slice,
    _options.editor,
    (id: string) => _options.cb(_options.editor, id, 0)
  )

  // Insert the transformed content at the drop position
  tr.replace(dropPosition.pos, dropPosition.pos, transformedSlice)

  // Set the selection to the dropped content
  const selection = TextSelection.create(
    tr.doc,
    dropPosition.pos,
    dropPosition.pos + transformedSlice.content.size
  )
  tr.setSelection(selection)

  // Dispatch the transaction
  dispatch(tr.scrollIntoView())

  return true // Prevent the default drop behavior
}

// Function to transform the slice if needed
function transformSlice(
  slice: Slice,
  editor: Editor,
  cb: (id: string) => undefined | string | void | false | null
): Slice {
  // Your transformation logic here

  return mapSlice(slice, (node) => {
    if (node.type.name === BaseHubBlock.name) {
      const id = cb(node.attrs.id)
      const bashubBlockNode = editor.state.schema.nodes[BaseHubBlock.name]

      if (id === false) return null
      if (id && bashubBlockNode) {
        return bashubBlockNode.create({
          id,
        })
      }
    } else if (node.marks) {
      const mark = node.marks.find(
        (mark) => mark.type.name === BaseHubInlineBlock.name
      )
      if (!mark) return node
      const id = cb(mark.attrs.id)
      // If the callback returns false, remove the mark
      if (id === false) {
        return node.mark(
          node.marks.filter(
            (mark) => mark.type.name !== BaseHubInlineBlock.name
          )
        )
      }
      if (id) {
        return node.mark([
          ...node.marks.filter(
            (mark) => mark.type.name !== BaseHubInlineBlock.name
          ),
          editor.state.schema.marks[BaseHubInlineBlock.name]!.create({
            id,
          }),
        ])
      }
    }
    return node
  })
}
